// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"style__iconContainer__8RJs0","icon":"style__icon__J4W+V"};